import { IOnChangesObject } from 'angular';

export const LendingProvider = {
    template: require('./lending-provider.html'),
    controller: class LendingProvider {
        private imagePreview: string;
        private logoTooltip: string;

        $onChanges(onChangesObj: IOnChangesObject): void {
            const imagePreview = onChangesObj.imagePreview.currentValue;
            if (imagePreview !== undefined && imagePreview !== '') {
                this.imagePreview = 'data:image/png;base64,' + imagePreview;
            } else {
                this.imagePreview = 'assets/images/defaultLogo.png';
                this.logoTooltip = 'Potrai caricare il tuo logo in Gestione Profilo.';
            }
        }
    },
    bindings: {
        imagePreview: '<',
        provider: '<'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/lending-provider/lending-provider.ts